exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".articles h2{text-align:center}@media(min-width: 992px){.articles h2{text-align:left}}.articles .container{max-width:900px;margin-top:2rem;margin-bottom:5em}.articles .container .article{margin:3rem 0}.articles .container .article .rounded-circle{width:198px;margin:1rem 0}.articles .container .article h3,.articles .container .article p,.articles .container .article button{text-align:center}@media(min-width: 992px){.articles .container .article h3,.articles .container .article p,.articles .container .article button{text-align:left}}.articles .container .article .center-sm{text-align:center;justify-content:center}@media(min-width: 992px){.articles .container .article .center-sm{text-align:left;justify-content:left}}.articles .container .article-title{font-size:2.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/Articles/Articles.scss
// module id = 7707
// module chunks = 13